import { m } from "framer-motion";

export const mentalplus = {
 mentalplus_tab_help: 'Mi boya',
 mentalplus_tab_vidos: 'Vídeos',
 mentalplus_tab_home: 'Mi mundo',
 mentalplus_tab_evolution: 'Mi evolución',
 mentalplus_filtre_ile: 'Isla',
 mentalplus_tab_ile_moi: 'Yo',
 mentalplus_tab_ile_amour: 'Amor',
 mentalplus_tab_ile_amis: 'Amigos',
 mentalplus_tab_ile_famille: 'Familia',
 mentalplus_tab_ile_ecrans: 'Pantalla',
 mentalplus_tab_ile_loisirs: 'Ocio',
 mentalplus_video_filtres: 'Filtros',
 mentalplus_video_enregistrees: 'Guardados',
 mentalplus_video_rechercher: 'Buscar',
 mentalplus_help_signes: 'Signos',
 mentalplus_help_solutions: 'Soluciones',
 mentalplus_help_num_soutiens: 'Números de apoyos',
 mentalplus_help_signes_question: '¿Cuáles son las señales que me hacen darme cuenta de que estoy empezando a sentirme mal?',
 mentalplus_help_solutions_question: '¿Qué soluciones pueden ayudarme a sentirme mejor?',
 mentalplus_help_num_epingle: 'Número fijado',
 mentalplus_help_num_utiles: 'Números útiles',
 mentalplus_help_num_epingle_choix: 'Elegir el número para fijar',
 mentalplus_help_num_valider: 'Confirmar este número',
 mentalplus_help_num_gerer: 'Gestionar mis números de emergencia',
 mentalplus_help_num_gerer_proches: 'Gestionar los números de mis contactos cercanos',
 mentalplus_help_num_enregistrer: 'Guardar',
 mentalplus_help_solutions_ajouter: 'Añadir una solución',
 mentalplus_help_ajouter: 'Añadir',
 mentalplus_help_signes_ajouter: 'Añadir un señal',
 mentalplus_help_num_proches_ajouter: 'Añadir un contacto cercano',
 mentalplus_help_num_proches_nom: 'Nombre del contacto (ej: Papá)',
 mentalplus_help_num_proches_numero: 'Número de teléfono',
 mentalplus_help_num_urgences: 'Números de emergencia',
 mentalplus_help_num_proches: 'Contactos cercanos',
 mentalplus_video_retour: 'Volver',
 mentalplus_video_tout_voir: 'Ver todo',
 mentalplus_video_renitialiser: 'Reiniciar',
 mentalplus_filtre_categories: 'Categorías',
 mentalplus_filtre_categories_explications: 'Explicaciones',
 mentalplus_filtre_categories_solutions: 'Soluciones',
 mentalplus_filtre_realisee: 'Realizada por',
 mentalplus_filtre_realisee_professionnels: 'Profesionales',
 mentalplus_filtre_realisee_communaute: 'Comunidad',
 mentalplus_filtre_realisee_2: 'Realizada para',
 mentalplus_filtre_realisee_collegiens: 'Estudiantes de secundaria',
 mentalplus_filtre_realisee_lyceens: 'Estudiantes de bachillerato',
 mentalplus_filtre_realisee_etudiants: 'Estudiantes universitarios',
 mentalplus_filtre_realisee_jeunes_actifs: 'Jóvenes activos',
 mentalplus_filtre_realisee_sans_activite: 'Sin actividad',
 mentalplus_filtre_trier: 'Ordenar por',
 mentalplus_filtre_trier_popularite: 'Popularidad',
 mentalplus_filtre_trier_recent: 'Reciente',
 mentalplus_filtre_trier_ancien: 'Antiguo',
 mentalplus_menu_share: 'Compartir Mental+',
 mentalplus_menu_profile: 'Perfil',
 mentalplus_menu_island_settings: 'Configuración de la isla',
 menu_share: 'Compartir',
 mentalplus_menu_conatct: 'Contáctanos',
 mentalplus_menu_objet: 'Asunto',
 mentalplus_menu_objet_champ: 'Selecciona un asunto', 
 mentalplus_menu_equipe: '¿Quiénes somos?',
 mentalplus_menu_signaler_un_bug: 'Reportar un error',
 mentalplus_menu_contacter_l_equipe: 'Contactar al equipo',
 mentalplus_menu_autre: 'Otro',
 mentalplus_menu_que_faire: '¿Qué hacer?',
 mentalplus_menu_son: 'Sonido',
 mentalplus_video_recherche: 'Ningún vídeo coincide con estos filtros.',
mentalplus_ile_moi_quizz: 'Cuestionario de ansiedad y depresión',
mentalplus_video_enregistree: 'No hay videos guardados por el momento.',
};
